import { z } from "zod";

import type { DragLocationHistory as Location } from "@atlaskit/pragmatic-drag-and-drop/dist/types/internal-types";
import type { DraggedItem } from "../components/shared/dragndrop/types";
import { SummaryContextType } from "../pages/inbound/shared/ActionsMenuContext";

export const assignShipmentTypeSchema = z.enum([
  "trap",
  "section",
  "route",
  "osad",
  "bucket",
  "shipment",
]);

export type AssignShipmentType = z.infer<typeof assignShipmentTypeSchema>;

type AssignShipment = {
  destination: DraggedItem;
  origin: DraggedItem;
  location: Location;
  destinationIndex: number;
  shipmentIds: number[];
  prePlanningType?: SummaryContextType;
};

type UnassignShipment = {
  shipmentIds: Array<number>;
  sourceType: AssignShipmentType;
  sourceId?: string;
};

export type AssignShipmentFn = (data: AssignShipment) => void;
export type UnassignShipmentFn = (data: UnassignShipment) => void;
